export default "__VITE_ASSET__DEwPR48r__"